export enum SprogLocale {
  Dansk = 'da',
  English = 'en'
}
